/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Status_ConsideringInputs */

const en_us2_community_status_considering = /** @type {(inputs: Community_Status_ConsideringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under consideration`)
};

const pt_br2_community_status_considering = /** @type {(inputs: Community_Status_ConsideringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em avaliação`)
};

const es_419_community_status_considering = /** @type {(inputs: Community_Status_ConsideringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En evaluación`)
};

const pt_pt2_community_status_considering = /** @type {(inputs: Community_Status_ConsideringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em avaliação`)
};

const fr_fr2_community_status_considering = /** @type {(inputs: Community_Status_ConsideringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À l'étude`)
};

const de_de2_community_status_considering = /** @type {(inputs: Community_Status_ConsideringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird geprüft`)
};

const it_it2_community_status_considering = /** @type {(inputs: Community_Status_ConsideringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In valutazione`)
};

/**
* | output |
* | --- |
* | "Under consideration" |
*
* @param {Community_Status_ConsideringInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_status_considering = /** @type {((inputs?: Community_Status_ConsideringInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Status_ConsideringInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_status_considering(inputs)
	if (locale === "es-419") return es_419_community_status_considering(inputs)
	if (locale === "pt-PT") return pt_pt2_community_status_considering(inputs)
	if (locale === "fr-FR") return fr_fr2_community_status_considering(inputs)
	if (locale === "de-DE") return de_de2_community_status_considering(inputs)
	if (locale === "it-IT") return it_it2_community_status_considering(inputs)
	return en_us2_community_status_considering(inputs)
});
export { community_status_considering as "community.status_considering" }